module.exports = __webpack_public_path__ + "static/media/esport-stage-crop.6a5c1f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/esport-stage-crop.jpg
// module id = 578
// module chunks = 0